import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import axios from 'axios';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import AccountList from '../../component/Account/AccountList';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import Main_Summer from '../../component/Summer/Main_Summer';
import Save_Date from '../../component/Save_Date';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import CallInfo from '../../component/CallInfo';
import Information from '../../component/Information';
import Info_Spring2 from '../../component/Spring/Info_Spring2';
import AccountList2 from '../../component/Account/AccountList2';
import Main_Fall from '../../component/Fall/Main_Fall';


const Thao = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "이원주 ♥ 타오 결혼합니다.";
    const openDesc = "2025년 6월 1일 일요일 12시 30분";
    const openThumb = "https://d39wt6wnedokd1.cloudfront.net/213/thumb.jpg";

    const lng = 128.415255422996;
    const lat = 36.1571069746721;

    const placeTelNum = "054-473-5000";

    const forCar = "네비게이션 '경상북도 구미시 산동읍 옥계2공단로 583' 입력\n\n* 대구 출발시: 가산 IC를 이용하는 것이 더 편리합니다.\n* 서울 출발시: 구미 IC를 이용하는 것이 더 편리합니다."
    const forParking = "건물 지상 주차장 이용"
    const forBus = "90, 90-2, 380-1, 404, 192, 890, 891, 891-1 \n옥계대백타운입구(양포파출소 앞) 정류장 하차 후 도보 15분"

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });

    // #A9261D
    // #AB5934
    // #836EA0
    const conceptStyle = {
        concept: "SUMMER",
        titleColor: "#000000",
        pointColor: "#AB5934",
        btnBgColor: "#AB5934",
        fontColor: "#000000",
        btnFontColor: "#ffffff",
        chatBgColor: "#F4F4F4",
        fontFamilyKo: "JejuMyeongjo",
        fontFamilyEn: "Milchella"
    }


    const title = "저희 결혼합니다";


    const msg1 = "서로가 마주 보며 다져온 사랑을\n이제 함께 한 곳을 바라보며 걸어갈 수 있는\n큰 사랑으로 키우고자 합니다."
    const msg2 = "저희 두 사람이 사랑의 이름으로 지켜 나갈수 있게 \n앞날을 축복해 주시면 감사하겠습니다."


    const parents = [
        {groom : "❁박금주 · 이윤실의 장남"},
        {bride : "이학두 · 최경숙의 차녀"}
    ]

    const groomAccountList = [
        {
            role: "신랑",
            name: "이원주",
            bank: "기업은행",
            accountNumber : "157-177746-01-017",
            isKakao : false
        }
        ,{
            role: "신랑 부",
            name: "이영길",
            bank: "하나은행",
            accountNumber : "541-910178-36507",
            isKakao : false
        }
        ,{
            role: "신랑 모",
            name: "이명숙",
            bank: "농협은행",
            accountNumber : "741066-56-023383",
            isKakao : false
        }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "Luong Thi Thao",
            bank: "하나은행",
            accountNumber : "349-910458-58507",
            isKakao : false
        }
        // ,{
        //     role: "신부 부",
        //     name: "강덕귀",
        //     bank: "국민은행",
        //     accountNumber : "827-24-0155-355",
        //     isKakao : false
        // }
        // ,{
        //     role: "신부",
        //     name: "배다민",
        //     bank: "농협은행",
        //     accountNumber : "352-1043-7794-53",
        //     isKakao : true,
        //     kakaoUrl : "https://qr.kakaopay.com/Ej7nwOd76"
        // }
    ]

    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const interviewContent = [
        {
            question : "우리의 설레였던 첫 만남 기억해?",
            groomAnswer: "너무 예뻤엉",
            brideAnswer: "나도 좋았어"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "너무 떨려요",
            brideAnswer: "긴장돼요~"
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "많이 사랑해",
            brideAnswer: "많이 고마웡"
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "잘해줄게요",
            brideAnswer: "행복합시다"
        }
        // ,{
        //     question : "마지막으로 손님들께 전하고 싶은 이야기는?",
        //     groomAnswer: "고맙습니다♥︎",
        //     brideAnswer: "많이많이요♥︎"
        // },
    ]

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "이원주",
            call: "010-3362-6552"
        }
        ,{
            role: "신랑 부",
            name: "이영길",
            call: "010-8585-6552"
        }
        ,{
            role: "신랑 모",
            name: "이명숙",
            call: "010-4501-6552"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "Luong \nThi Thao",
            call: "010-9672-1511"
        }
        // ,{
        //     role: "신부 부",
        //     name: "강덕귀",
        //     call: "010-3725-3239"
        // }
        // ,{
        //     role: "신부 모",
        //     name: "박수정",
        //     call: "010-3711-1922"
        // }
    ]

    const informationList =[
        {
            title : "ATM 기기 안내",
            content : "주변엔 ATM기기가 없습니다. \n이점 양해 부탁드립니다."
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstNameEn = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    // ex. Kim Gayeong
    const getRemoveSpaceName = (fullName) => {
        const nameParts = fullName.split(' '); // 문자열을 띄어쓰기로 분리
        const firstName = nameParts[0]; // 첫 번째 단어 유지
        const restName = nameParts.slice(1).join(''); // 나머지 단어를 소문자로 변경하고 결합
        return firstName + ' ' + restName.charAt(0).toUpperCase() + restName.slice(1).toLowerCase();
    };

        // 성을 제외하고 이름만 추출 ex.Gayeong
        const getFirstEnName = (fullName) => {
            const nameParts = fullName.split(' '); 
            const firstName = nameParts.slice(1).join(''); 
            return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
        };

        const toLowerCaseString = (str) => {
            const parts = str.split(" ");
            if (parts.length < 2) return str; // 성과 이름이 없으면 그대로 반환
            const firstName = parts[1] + (parts[2] || ""); // 이름 부분 결합
            const formattedFirstName = firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase(); // 이름의 첫 글자만 대문자로 변환
            return `${parts[0]} ${formattedFirstName}`;
        };
        
        // 브라운 #5b0100
        // #761B40
        // #423866
        // #d98db9
        // #FF8A83
    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#AB5934"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept} />
                    <Main_Fall brideNameEn={toLowerCaseString(weddingData.brideNameEn)} groomNameEn={toLowerCaseString(weddingData.groomNameEn)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <Save_Date color={conceptStyle.pointColor} isBorder={true} marginTop={"100px"} marginBottom={"10px"} fontSize={"13px"} />
                    <Info_Spring2 weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>
                    <Letter title={title} msg1={msg1} msg2={msg2} conceptStyle={conceptStyle} />
                    <CallInfo marginTop={"30px"} conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/>
                    <Dday_Spring brideName={weddingData.brideName} groomName={getFirstKoName(weddingData.groomName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={6} photoWidth={"150px"} photoHeight={"235px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>
                    {/* <Information conceptStyle={conceptStyle} informationList={informationList} /> */}
                    <MotionWrapper initialY={50}>
                        <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} />
                        <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>
                    <Location_Desc isPoint={true} forCar={forCar} forParking={forParking} forBus={forBus} conceptStyle={conceptStyle}/>
                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                    <Footer />
                </>
            )}
        </div>
    );
    
};

export default Thao;